/**
 * Permission before anything goes to OpenAI (App Store guideline 5.1.2(i):
 * personal data shared with a third-party AI must be disclosed and agreed
 * to first). Asked once per device, before Orion's chat opens and before
 * any "write it for me" / "polish my words" request. Added 2026-09-24 for
 * the 2.0 review; the app sent Orion's conversations to OpenAI without
 * saying so.
 */
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Alert } from 'react-native';

const CONSENT_KEY = '@ai_consent_v1';

let asking: Promise<boolean> | null = null;

export async function hasAiConsent(): Promise<boolean> {
  try {
    return (await AsyncStorage.getItem(CONSENT_KEY)) === 'granted';
  } catch {
    return false;
  }
}

/** Resolves true when the person has agreed (now or before); false otherwise. */
export function ensureAiConsent(): Promise<boolean> {
  if (asking) return asking;
  asking = (async () => {
    if (await hasAiConsent()) return true;
    return new Promise<boolean>((resolve) => {
      Alert.alert(
        'Orion uses OpenAI',
        "Orion, FinalKey's assistant, is powered by OpenAI. When you use Orion, what you write or say to it " +
          '(including any account details you ask it to save) and the checklist information it reads while ' +
          'helping you are sent to OpenAI to produce its replies. Your document files are not sent.\n\n' +
          'You can use FinalKey without Orion.',
        [
          { text: 'Not now', style: 'cancel', onPress: () => resolve(false) },
          {
            text: 'Agree',
            onPress: async () => {
              try {
                await AsyncStorage.setItem(CONSENT_KEY, 'granted');
              } catch {
                /* still agreed for this use */
              }
              resolve(true);
            },
          },
        ],
        { cancelable: true, onDismiss: () => resolve(false) },
      );
    });
  })().finally(() => {
    asking = null;
  });
  return asking;
}
